import { useState } from 'react';
import { PrimaryButton } from '../atoms';
import { ProcessingModal } from './ProcessingModal';
import { handleClose, handleOpen } from '../../common';
import type { TCourse } from '../../common/types/Course';
import { APIEndPoints, Request } from '../../apis';
import { z } from 'zod';

type TCreateCourseLink = {
  courseDetails: TCourse;
  setTriggerUpdate: () => void;
};

type TProcessedMsg = string | null;

const CreateCourseLink = ({
  courseDetails,
  setTriggerUpdate
}: TCreateCourseLink) => {
  const [processingModalOpen, setProcessingModalOpen] = useState(false);
  const [creatingLink, setCreatingLink] = useState(false);
  const [processedMsg, setpPocessedMsg] = useState<TProcessedMsg>(null);
  const [creatingLinkSuccessful, setCreatingLinkSuccessful] = useState(false);
  // const [triggerUpdate, setTriggerUpdate] = useState(false);

  const tokenSchema = z.string();
  const urlPatchSchema = z.object({
    id: z.string(),
    status: z.number(),
    message: z.string()
  });

  const anytimeUrlBase = process.env.REACT_APP_ANYTIME_URL;

  const createLink = async () => {
    setCreatingLinkSuccessful(false);
    setCreatingLink(true);
    handleOpen(setProcessingModalOpen);

    if (courseDetails) {
      if (courseDetails.productType) {
        try {
          const token = await Request.post(
            `${APIEndPoints.courseJWT}/?access_token`,
            tokenSchema,
            {
              courseId: courseDetails.id,
              merchantApplying: false,
              productType: courseDetails.productType,
              merchantId: courseDetails.merchantId
            },
            {
              merchant: courseDetails.merchantId
            }
          );

          let courseUrl =
            anytimeUrlBase + '/customer-verification?jwt=' + token;

          courseUrl += '&productType=' + courseDetails.productType;

          try {
            const urlPatch = await Request.patch(
              `${APIEndPoints.courses}/${courseDetails.merchantId}/${courseDetails.id}/url?access_token`,
              urlPatchSchema,
              {
                url: courseUrl
              }
            );

            setCreatingLink(false);
            setCreatingLinkSuccessful(true);
            setpPocessedMsg('Link has been added successfully');
          } catch {
            setCreatingLink(false);
            setpPocessedMsg('Something went wrong when adding a link');
          }
        } catch {
          setCreatingLink(false);
          setpPocessedMsg('Something went wrong when adding a link');
        }
      } else {
        setCreatingLink(false);
        setpPocessedMsg(`Couldn't find product type`);
      }
    } else {
      setCreatingLink(false);
      setpPocessedMsg(`Couldn't find course details`);
    }
  };

  const refreshPage = () => {
    if (creatingLinkSuccessful) {
      setTriggerUpdate();
    }
    handleClose(setProcessingModalOpen);
  };

  return (
    <>
      <PrimaryButton type="button" onClick={() => createLink()}>
        Create Link <span className="material-symbols-rounded">link</span>
      </PrimaryButton>
      <ProcessingModal
        isModalOpen={processingModalOpen}
        handleModalClose={() => refreshPage()}
        processing={creatingLink}
        title="Creating Link"
        processedMsg={processedMsg}
      />
    </>
  );
};

export { CreateCourseLink };
